import { Appointment } from './types';

export const APPOINTMENT_CARD_BASE_CLASS =
  'rounded-lg border-l-4 shadow-sm cursor-pointer w-full text-left overflow-hidden';
export const APPOINTMENT_CARD_PADDING_COMPACT_CLASS = 'px-2 py-1';
export const APPOINTMENT_CARD_PADDING_REGULAR_CLASS = 'px-2 py-1.5';
export const APPOINTMENT_CARD_TITLE_CLASS = 'text-xs font-medium truncate leading-tight';
export const APPOINTMENT_CARD_TIME_CLASS = 'text-[11px] text-gray-600 truncate leading-tight';
export const APPOINTMENT_CARD_META_CLASS = 'text-[11px] text-gray-500 truncate leading-tight';

export const getAppointmentStatusCardClass = (status: Appointment['status']): string => {
  switch (status) {
    case 'scheduled':
      return 'bg-blue-100 border-blue-300 text-blue-800';
    case 'confirmed':
      return 'bg-green-100 border-green-300 text-green-800';
    case 'in_progress':
      return 'bg-yellow-100 border-yellow-300 text-yellow-800';
    case 'completed':
      return 'bg-gray-100 border-gray-300 text-gray-800';
    case 'cancelled':
      return 'bg-red-100 border-red-300 text-red-800';
    case 'no_show':
      return 'bg-orange-100 border-orange-300 text-orange-800';
    default:
      return 'bg-blue-100 border-blue-300 text-blue-800';
  }
};

export const getAppointmentStatusDotClass = (status: Appointment['status']): string => {
  switch (status) {
    case 'scheduled':
      return 'bg-blue-500';
    case 'confirmed':
      return 'bg-green-500';
    case 'in_progress':
      return 'bg-yellow-500';
    case 'completed':
      return 'bg-gray-500';
    case 'cancelled':
      return 'bg-red-500';
    case 'no_show':
      return 'bg-orange-500';
    default:
      return 'bg-blue-500';
  }
};
